import React, { useState, useEffect } from "react";
import { Card, IconButton } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import api from "core/interceptors/api";
import ProductDetailsModal from "./components/ProductsDetailModal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const InactiveProductsPage = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const email = localStorage.getItem("email");

    useEffect(() => {
        fetchInactiveProducts();
    }, [email]);

    const fetchInactiveProducts = async () => {
        setLoading(true);
        try {
            const response = await api.get("/product/fetch/inactive", { params: { email } });
            if (response.data.status === 1) {
                setProducts(response.data.products);
            }
        } catch (error) {
            console.error("Error fetching inactive products:", error);
        } finally {
            setLoading(false);
        }
    };

    const onView = (product) => {
        setSelectedProduct(product);
        setOpenModal(true);
    };

    const columns = [
        {
            Header: "S.No.",
            accessor: "s_no",
            sortable: true,
        },
        {
            Header: "Product Name",
            accessor: "product_name",
            sortable: true,
        },
        {
            Header: "Category",
            accessor: "category_name",
            sortable: true,
        },
        {
            Header: "Price",
            accessor: "price",
            sortable: true,
        },
        {
            Header: "Stock Quantity",
            accessor: "stock_quantity",
            sortable: true,
        },
        {
            Header: "Options",
            accessor: "options",
            Cell: ({ row }) => (
                <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <IconButton color="info" onClick={() => onView(row.original)}>
                        <VisibilityIcon />
                    </IconButton>
                </div>
            )
        }
    ];

    const startIndex = page * rowsPerPage;
    const paginatedProducts = products.slice(startIndex, startIndex + rowsPerPage);
    const data = paginatedProducts.map((product, index) => ({
        s_no: startIndex + index + 1,
        ...product,
        specification: Array.isArray(product?.specification)
            ? product.specification
            : (typeof product?.specification === "string"
                ? JSON.parse(product.specification)
                : []),
    }));

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Card>
                    <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                        <MDTypography variant="h6" color="white">Inactive Products</MDTypography>
                    </MDBox>
                    <MDBox p={3}>
                        <DataTable
                            table={{ columns, rows: data }}
                            isSorted={true}
                            entriesPerPage={{ defaultValue: rowsPerPage, entries: [5, 10, 15, 20, 25] }}
                            showTotalEntries={true}
                            canSearch={true}
                            noEndBorder
                            pagination={{
                                variant: "contained",
                                color: "dark",
                                page: page,
                                onPageChange: handlePageChange,
                                rowsPerPage: rowsPerPage,
                                onRowsPerPageChange: handleRowsPerPageChange,
                                count: products.length,
                            }}
                        />
                    </MDBox>
                    <ProductDetailsModal
                        open={openModal}
                        onClose={() => setOpenModal(false)}
                        product={selectedProduct}
                    />
                </Card>
            </MDBox>
        </DashboardLayout>
    );
};

export default InactiveProductsPage;
